import React from "react"
import { BackArrow } from "icons"
import IconComponent from "components/IconComponent"
import Button from "storybookComponents/Button"
import Switch from 'components/Switch/simpleSwitch'


const Header = ({ classes, handleBackCallback, handleToggleEmails, item, toggleModal, onSave, active, ...props }) => {

  const onToggleEmails = (toggle, prev) => {
    return handleToggleEmails(toggle, prev, item.emailName, item.graphqlKey)
  }
  return (
    <div className={classes.header}>
      <div className={classes.leftHeader}>
        <IconComponent Component={BackArrow} onHoverColor="#26bbed" onClick={handleBackCallback} />
        <span className={classes.titleTextEdit}>Edit:&nbsp;</span>
        <span className={classes.titleTextName}>{item.emailName}</span>
      </div>
      <div className={classes.rightHeader}>
        <div className={classes.emailText}>
          Email:
                  </div>
        <Switch
          toggled={item.active}
          onToggle={onToggleEmails}
          id={item.email_id}
        />
        <div className={classes.divider}></div>
        <Button className={classes.buttonStyle} onClick={handleBackCallback} variant="tertiary">Cancel</Button>
        <Button className={classes.buttonStyle} onClick={() => toggleModal(item)} variant="secondary">Send Test</Button>
        <Button className={classes.buttonStyle} state={active} onClick={onSave} >Save</Button>
      </div>
    </div>
  )
}


export default Header